import { render, staticRenderFns } from "./Cascader.vue?vue&type=template&id=67400e79&scoped=true"
import script from "./Cascader.vue?vue&type=script&lang=js"
export * from "./Cascader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67400e79",
  null
  
)

export default component.exports